import { LocalStore } from 'shared-utils';

const storage = new LocalStore();

export default storage;